<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <!-- Bedding Type -->
                <b-col cols="12" v-if="!isReadOnly">
                    <ValidationProvider name="bedding_type" rules="required" v-slot="{ errors }">
                        <b-form-group label="Bedding Set">
                            <ParameterSelectbox
                                code="housing_reservations.bedding_type"
                                v-model="request_data.bedding_type"
                                :validate-error="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" v-else>
                    <b-form-group label="Bedding Set">
                        <ParameterSelectbox
                            code="housing_reservations.bedding_type"
                            v-model="request_data.bedding_type"
                            :disabled="true"
                        />
                    </b-form-group>
                </b-col>

                <!-- Save Button -->
                <b-col cols="12" class="d-flex justify-content-center align-items-center" v-if="!isReadOnly">
                    <b-form-group class="mb-0">
                        <b-button variant="primary" block @click="approved" :disabled="formLoading">
                            {{ $t('save').toUpperCase() }}
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
    // Services
    import StudentRequestService from '@/services/StudentRequestService'
    import {EventBus} from "@/main";
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";

    export default {
        components: {
            ParameterSelectbox,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            data:{
                type:Object
            },
            isReadOnly:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                formLoading: false,
                request_data: {}
            }
        },
        mounted() {
          EventBus.$on('approvedRequestForm',(event)=>{
               if (event.constantCode==='housing_request.bedding_set_request_text'){
                   this.save()
               }
          })
        },
        created() {
            this.request_data = this.data.request_data || {};
            this.request_data.housing_bed_id = this.data.housing_bed_id;
            this.request_data.bedding_type = this.request_data.bedding_type || null;
        },
        methods: {
           async approved(){
                const isValid = await this.$refs.formModalValidate.validate();
                if (!isValid) {
                    return
                }
                EventBus.$emit('bed_hold_request',{
                    constant:'housing_request.bedding_set_request_text'
                    }
                )
            },
            async save() {
            const isValid = await this.$refs.formModalValidate.validate();
             if (isValid) {
                 const config = {
                     headers: {
                         'Content-Type': 'multipart/form-data'
                     },
                 };

                 const formData = new FormData();
                 formData.append('request_data[bedding_type]', this.request_data.bedding_type);
                 formData.append('request_type', 'bedding_set_request');
                 formData.append('housing_reservation_id', this.data.id);

            StudentRequestService.studentRequest(formData,config)
                .then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$router.push('/housing/request/list');
                })
                .catch(e => {
                    EventBus.$emit('formClearRequest')
                    this.showErrors(e, this.$refs.formModalValidate);
                })
           }
          }
        }
    }
</script>
